export default "__VITE_ASSET__BYebM2uu__"